import React from 'react';
import KickImage from 'Reuseables/KickImage';
import ScrollToTopOnMount from '../ScrollToTop/ScrollToTopOnMount';

const withScrollTo = (WrapComponent, scrollStepInPx = 50, delayInMs = 10) => {
  const scrollRestoration = 'scrollRestoration' in window.history;
  if(scrollRestoration) window.history.scrollRestoration = 'manual';
  return class withScrollTo extends React.Component{
    constructor(props){
      super(props);
      this.state = {
        intervalId: null,
        bufferPosY: 0,
        scrollStepInPx,
        delayInMs
      }
    }

    scrollToTop = () => {
      this.setState({ bufferPosY: 0 });
      this.scrollTo();
    }

    validateIsOnTopPage = (bufferPosY = 0) => window.pageYOffset + bufferPosY <= bufferPosY

    scrollTo = (x=0, y=0) => window.scrollTo(x, y)

    _scrollStep() {
      const { pageYOffset } = this.state;
      if (window.pageYOffset <= this.state.bufferPosY && this.state.intervalId) {
        const { intervalId } = this.state;
        this.setState({
          intervalId:null
        },()=>{
          clearInterval(intervalId);
        })
      }
      window.scroll(0, window.pageYOffset  - this.state.scrollStepInPx);
    }

    scrollYAnimated = async (bufferPosY = 0) => {
      if(!this.validateIsOnTopPage(bufferPosY) && !this.state.intervalId){
        const intervalId = setInterval(this._scrollStep.bind(this), this.state.delayInMs);
        await this.setState({ intervalId: intervalId, bufferPosY });
      }
    }

    componentWillUnmount(){
      if(this.state.intervalId){
        clearInterval(this.state.intervalId);
      }
    }

    render(){
      const { children, ...props } = this.props;
      return (
        <ScrollToTopOnMount>
          <WrapComponent
            {...props}
            clientScroll={{
              scrollStepInPx: this.state.scrollStepInPx,
              delayInMs: this.state.delayInMs,
              scrollToTop: this.scrollToTop,
              scrollTo: this.scrollTo,
              validateIsOnTopPage: this.validateIsOnTopPage,
              scrollYAnimated: this.scrollYAnimated
            }}
          >
            { children }
          </WrapComponent>
        </ScrollToTopOnMount>
      )
    }
  }
}

export default withScrollTo;